import { useEffect, useState } from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { api, imgUrl } from "@/lib/api";

export const FestivalBanners = ({ onOpen }) => {
  const [banners, setBanners] = useState([]);
  useEffect(() => { api.get("/banners").then((r) => setBanners(r.data)).catch(() => {}); }, []);
  if (!banners.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 mt-6 sm:mt-8" data-testid="festival-banners">
      <div className={`grid gap-4 sm:gap-6 ${banners.length > 1 ? "md:grid-cols-2" : ""}`}>
        {banners.map((b, i) => (
          <button key={b.id} onClick={() => onOpen(b)} data-testid={`festival-banner-${b.id}`} style={{ animationDelay: `${i * 80}ms` }}
            className="rise group relative text-left rounded-3xl overflow-hidden min-h-[200px] sm:min-h-[240px] bg-accent">
            {b.image && <img src={imgUrl(b.image)} alt={b.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
            <div className="absolute inset-0 bg-gradient-to-r from-[#5a2412]/90 via-[#5a2412]/55 to-transparent" />
            <div className="relative p-6 sm:p-8 max-w-lg text-white flex flex-col h-full justify-center gap-2">
              <p className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#ffd9a0] flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5" /> Festival special</p>
              <h2 className="font-display text-3xl sm:text-4xl font-semibold leading-tight text-white" data-testid={`festival-banner-title-${b.id}`}>{b.title}</h2>
              {b.text && <p className="text-sm text-white/85">{b.text}</p>}
              <span className="mt-2 inline-flex items-center gap-2 self-start h-10 px-5 rounded-full bg-white text-[#5a2412] text-sm font-bold group-hover:gap-3 transition-[gap]">
                {b.cta || "Shop now"} <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};
